import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Game from './Game';
import GameObject from './GameObject/GameObject';
import { sentryInit } from './Sentry';
import Environment from './Utility/Environment';
import { GameCheats } from './Cheats';
import CheatsManager from "CheatsManager";
import { getGameConfig } from '@platform/GameConfig';
import './Utility/PixiExtends';

declare global {
    interface Window {
        game: typeof Game;
        GameObject: typeof GameObject;
        sgPlatform: string;
        simulating: boolean;
    }
}

function sentryInitAfterGameConfig() {
    if (process?.env.NODE_ENV === Environment.PRODUCTION) {
        sentryInit();
    }
}

new CheatsManager({
    autoEnableCheats: process?.env.NODE_ENV === Environment.DEVELOPMENT,
    enableCheatsFunc: () => {
        (window as any).cheats = GameCheats;
        window.game = Game;
    },
});

//@ts-ignore
window.onWrapperReady = () => {
    getGameConfig().then(config => {
        PIXI.utils.skipHello();
        return Game.init(config);
    });
}